import { render } from "./HalamanDai.vue?vue&type=template&id=bcb63ce8&scoped=true"
import script from "./HalamanDai.vue?vue&type=script&lang=js"
export * from "./HalamanDai.vue?vue&type=script&lang=js"

import "./HalamanDai.vue?vue&type=style&index=0&id=bcb63ce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb63ce8"]])

export default __exports__